module.exports = __webpack_public_path__ + "img/logoviejo.png.6dbc3635.webp";